import { ACTIONS } from 'actions/hit-animation';

const initialState = {
  showHitAnimation: false,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.TOGGLE_HIT_ANIMATION: {
      const { showHitAnimation } = payload;

      return {
        showHitAnimation,
      };
    }
    default:
      return state;
  }
}
